import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { TimeService } from 'src/app/time.service';
import { HttpClient } from '@angular/common/http';
import { HttpService } from 'src/app/http.service';

export interface InvoiceHistory{
  version:number,
  time:string,
  updated_by:string,
  status:string,
  comment:string,
  view:string
}

@Component({
  selector: 'app-invoice-history',
  templateUrl: './invoice-history.component.html',
  styleUrls: ['./invoice-history.component.scss']
})
export class InvoiceHistoryComponent implements OnInit {

  displayColumns = ["status","updated_by","datetime","comment","view"];
  history_data = [];
  constructor(private http:HttpService ,public timeService:TimeService, private dialogRef: MatDialogRef<InvoiceHistoryComponent>,@Inject(MAT_DIALOG_DATA) public parentData) { }

  ngOnInit() {
    this.getInvoiceHistory();
  }

  getInvoiceHistory(){
    let shipment_id = this.parentData.shipment_id;
    this.http.get('carrier_invoice/by_shipment?shipment_id=' + shipment_id, '', 1).subscribe(
      (response: any) => {
        if (response.statusCode == 200) {
           response.data.forEach(e => {
            let temp:any = {}
            temp.version = e.unique_code;
            temp.invoiceNo = e.IINC.custom ? e.IINC.custom : e.IINC.default;
            temp.datetime = this.timeService.toShortDateTime(e.created_at),
            temp.updated_by =  e.carrier_user.name;
            temp.status = e.status;
            temp.pdf_link =  e.pdf_link;
            temp.comment = e.comments || 'N/A';
            temp.view = temp.invoiceNo || 'N/A';
            this.history_data.push(temp);
          });
        }
      });
  }


  closeModal(){
    this.dialogRef.close();
  }

}
